import axios from 'axios';
import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import qs from 'qs';
import moment from 'moment';
import actions from '../actions/setting_data';
import userActions from '../actions/user';
import loginActions from '../actions/login';
import rf from '../../requests/RequestFactory';
// saga effect
import { BASE_URL } from '../../consts';
import utils from '../../common/utils';
import favoritesActions from '../actions/favorites';

function* fetchAuthIfNeed() {
  console.log('=== fetchAuthIfNeed ===');
  const strSession = window.localStorage.getItem('session');
  const session = JSON.parse(strSession || '{}');
  // check token expired
  if (!!session && moment(session.time_expired / 1000).isAfter()) {
    console.log('=== OK ===');
    yield put(loginActions.loginNormalSucceed(session));
    // add token for axios
    window.axios = axios.create({
      baseURL: BASE_URL,
      headers: {
        token: session.token,
      },
      paramsSerializer(params) {
        return qs.stringify(params);
      },
    });

    yield put(userActions.fetchUserBalancesAction());
    yield put(userActions.fetchUserInfoAction());
  }
}

function* saveMasterData() {
  console.log('=== saveMasterData ===');
  const masterData = JSON.parse(localStorage.getItem('CRYPTO'));
  yield put(actions.fetchAllCoinActionSucceed(masterData.coins));
  yield put(actions.fetchCoinSettingActionSucceed(masterData.settings));
  yield put(actions.fetchLimitWithdrawalSucceedAction(masterData.withdrawal_limits));
}

function* fetchSettingIfNeed() {
  try {
    if (localStorage.getItem('CRYPTO_HASH')) {
      const crypto_hash = yield call(() => rf.getRequest('SettingRequest').fetchSettingHash());

      const hash = localStorage.getItem('CRYPTO_HASH');
      if (hash === crypto_hash.data) {
        yield saveMasterData();
        return;
      }
    }

    const { data, hash } = yield call(() => rf.getRequest('SettingRequest').fetchCryptoSetting());
    yield localStorage.setItem('CRYPTO', JSON.stringify(data));
    yield localStorage.setItem('CRYPTO_HASH', hash);

    yield saveMasterData();
  } catch (err) {
    console.log(err);
  }
}

function* fetchInit() {
  try {
    yield put(actions.fetchHashSetting());
    // yield utils.resetCacheTimeTVChart();
    yield fetchAuthIfNeed();
    yield fetchSettingIfNeed();

    const markets = yield call(() => rf.getRequest('SettingRequest').fetchMarkets());
    // TODO change follow user
    yield put(actions.fetchMarketActionSucceed(markets.data));
    // yield favorites
    if (window.$isAuthenticated) {
      yield put(favoritesActions.fetchFavoritesAction());
    } else {
      yield put(favoritesActions.localFetchFavoritesAction());
    }
  } catch (err) {
    console.log(err, 'err');
  }
}

function* watchInit() {
  yield takeLatest('@@__INIT__', fetchInit);
}

export default function* rootSaga() {
  yield all([fork(watchInit)]);
}
